import http from "@/apps/shared/baseService/config";
import { EventBus } from "@/main";

const base = {
  rota: "admin-onboarding",
  nome: "Onboarding Admin"
};

export const service = {
  updateProgress: data =>
    http.post(`/admin/funcionarios/update-onboarding-progress`, data)
};

const module = {
  namespaced: true,
  state: () => ({
    show: false,
    minimized: false,
    minimizing: false,
    stepKey: "payments",
    completed: {}
  }),
  getters: {
    get_show:    state => state.show,
    get_stepKey: state => state.stepKey,
    get_completed: state => state.completed,

    get_steps: () => [
      {
        key: "payments",
        icon: "mdi-credit-card-plus-outline",
        title: "Cadastrar formas de pagamento",
        description: "Configure dinheiro, maquininhas, fiado e taxas.",
        route: "/configurar-loja?tab=payments&onboarding=payments",
        guide: "Cadastre pelo menos uma forma dinamica alem do dinheiro. Se for maquineta, informe a taxa para os relatorios ficarem confiaveis.",
        tips: ["Dinheiro fica sempre ativo", "Maquininhas podem ter taxa", "Mudancas atualizam sem relogar"]
      },
      {
        key: "logo",
        icon: "mdi-image-plus-outline",
        title: "Adicionar logo da empresa",
        description: "A logo aparece em orçamentos e documentos.",
        route: "/configurar-loja?tab=company&onboarding=logo",
        guide: "Suba a logo e revise os dados da empresa. Isso deixa orcamento, recibo e documentos com cara profissional.",
        tips: ["Clique na imagem da empresa", "Revise telefone e endereco", "Salve antes de voltar"]
      },
      {
        key: "employee",
        icon: "mdi-account-plus-outline",
        title: "Cadastrar 1 funcionário",
        description: "Convide alguém para atender, vender ou acompanhar.",
        route: "/funcionarios?onboarding=employee",
        guide: "Crie um funcionario para testar atendimento, followers e notificacoes em tempo real entre envolvidos.",
        tips: ["Adicione nome e permissao", "Use para testar notificacoes", "Depois ajuste acessos finos"]
      },
      {
        key: "budgetText",
        icon: "mdi-text-box-edit-outline",
        title: "Cadastrar textos do orçamento",
        description: "Padronize observações, validade e mensagens impressas.",
        route: "/configurar-loja?tab=receipt&onboarding=budgetText",
        guide: "Defina cabecalho, rodape, observacao curta e validade da proposta para padronizar a impressao.",
        tips: ["Cabecalho e rodape", "Validade da proposta", "Observacao curta no orcamento"]
      }
    ],

    get_active_step: (state, getters) =>
      getters.get_steps.find(s => s.key === state.stepKey) || getters.get_steps[0],

    get_done: (state, getters) =>
      getters.get_steps.every(s => state.completed[s.key]),

    get_progress_text: (state, getters) => {
      const done = getters.get_steps.filter(s => state.completed[s.key]).length;
      return `${done}/${getters.get_steps.length} etapas concluidas`;
    }
  },
  mutations: {
    SET_SHOW:       (state, v) => (state.show = v),
    SET_MINIMIZED:  (state, v) => (state.minimized = v),
    SET_MINIMIZING: (state, v) => (state.minimizing = v),
    SET_STEP_KEY:   (state, v) => (state.stepKey = v),
    MERGE_COMPLETED:(state, payload) => {
      state.completed = { ...state.completed, ...payload };
    },
    RESTORE_PROGRESS:(state, payload) => {
      if (payload.completed) state.completed = { ...state.completed, ...payload.completed };
      if (payload.stepKey)   state.stepKey = payload.stepKey;
    },
    RESET: (state) => {
      state.show = false; state.minimized = false; state.minimizing = false; state.stepKey = "payments"; state.completed = {};
    }
  },
  actions: {
    check_and_open: ({ commit, dispatch, state }, { route }) => {
      const EXCLUDED_ROUTES = [
        "/", "/login", "/cadastro", "/recover-pass",
        "/auth", "/activate-account",
        "/escolher-empresa", "/criar-empresa", "/criar-sessao"
      ];
      const routePath = route?.path || "";
      const isExcludedRoute = EXCLUDED_ROUTES.some(path =>
        path === "/" ? routePath === path : routePath.includes(path)
      );

      if (!localStorage.token || isExcludedRoute) {
        commit("SET_SHOW", false);
        return;
      }

      let user = {};
      try { user = JSON.parse(localStorage.user); } catch {}
      if (!user?._id || !user.admin) return;

      const doneKey = `stonepro-admin-onboarding:${user._id}`;
      if (localStorage.getItem(doneKey) === "done") return;
      if (user.onboarding_progress?.finished) return;

      dispatch("restore");

      const stepRoutes = ["/configurar-loja", "/funcionarios"];
      const onStepRoute = stepRoutes.some(p => route.path.startsWith(p));

      if (onStepRoute) {
        if (state.show) dispatch("minimize");
        else commit("SET_MINIMIZED", true);
      } else {
        commit("SET_MINIMIZED", false);
      }

      commit("SET_SHOW", true);
    },

    minimize: ({ commit, state }) => {
      if (state.minimized || state.minimizing) return;
      commit("SET_MINIMIZING", true);
      setTimeout(() => {
        if (!state.minimizing) return;
        commit("SET_MINIMIZED", true);
        commit("SET_MINIMIZING", false);
      }, 350);
    },

    expand: ({ commit, state }) => {
      if (state.minimizing) commit("SET_MINIMIZING", false);
      commit("SET_MINIMIZED", false);
    },

    restore: ({ commit }) => {
      let user = {};
      try { user = JSON.parse(localStorage.user); } catch {}
      if (!user?._id) return;

      const key = `stonepro-admin-onboarding-progress:${user._id}`;
      try {
        const saved = JSON.parse(localStorage.getItem(key) || "{}");
        commit("RESTORE_PROGRESS", { completed: saved.completed, stepKey: saved.stepKey });
      } catch {}
    },

    persist: ({ state }) => {
      let user = {};
      try { user = JSON.parse(localStorage.user); } catch {}
      if (!user?._id) return;

      const key = `stonepro-admin-onboarding-progress:${user._id}`;
      localStorage.setItem(key, JSON.stringify({
        completed: state.completed,
        stepKey: state.stepKey
      }));
    },

    sync_to_backend: ({ state }, extras = {}) => {
      const payload = { ...extras };
      if (state.completed && Object.keys(state.completed).length) {
        payload.completed = state.completed;
      }
      if (!Object.keys(payload).length) return;
      return service.updateProgress(payload).catch(() => {});
    },

    complete_step: ({ commit, state, dispatch }, step) => {
      const completed = { [step.key]: true };
      commit("MERGE_COMPLETED", completed);

      const stepKeys = ["payments", "logo", "employee", "budgetText"];
      const idx = stepKeys.findIndex(k => k === step.key);
      const next = stepKeys[idx + 1];
      if (next) commit("SET_STEP_KEY", next);

      dispatch("persist");
      dispatch("sync_to_backend");

      if (stepKeys.every(k => state.completed[k])) {
        dispatch("expand");
      }
    },

    select_step: ({ commit, dispatch }, step) => {
      commit("SET_STEP_KEY", step.key);
      dispatch("persist");
    },

    open_step: ({ dispatch }, { step, router }) => {
      dispatch("select_step", step);
      const navigation = router.push(step.route).catch(() => {});
      Promise.resolve(navigation).finally(() => dispatch("minimize"));
    },

    finish: ({ commit, dispatch }) => {
      let user = {};
      try { user = JSON.parse(localStorage.user); } catch {}
      if (user?._id) {
        localStorage.setItem(`stonepro-admin-onboarding:${user._id}`, "done");
      }

      dispatch("sync_to_backend", { finished: true });
      commit("SET_SHOW", false);
    },

    listen_saves: ({ dispatch }) => {
      EventBus.$on("savePaymentSysConfig", () => {
        dispatch("mark_step_from_event", "payments");
      });
      EventBus.$on("storeProfileUpdated", () => {
        dispatch("mark_step_from_event", "logo");
      });
      EventBus.$on("saveReceiptConfig", () => {
        dispatch("mark_step_from_event", "budgetText");
      });
      EventBus.$on("funcionarioCriado", () => {
        dispatch("mark_step_from_event", "employee");
      });
    },

    mark_step_from_event: ({ state, dispatch }, stepKey) => {
      if (state.completed[stepKey]) return;
      const steps = [
        { key: "payments" }, { key: "logo" },
        { key: "employee" }, { key: "budgetText" }
      ];
      const step = steps.find(s => s.key === stepKey);
      if (step) dispatch("complete_step", step);
    }
  }
};

const routes = [];

export default { service, module, routes };
